export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://twitter.com/intent/tweet',
                params: {
                    text: 'title',
                    url: 'url',
                    hashtags: 'hashtags',
                    via: 'via',
                },
            },
        },
    },

    contentOptions: {
        hashtags: '',
        via: '',
    },

    popupDimensions: [550, 420],

    i18n: {
        az: 'X',
        be: 'X',
        en: 'X',
        hy: 'X',
        ka: 'X',
        kk: 'X',
        ro: 'X',
        ru: 'X',
        tr: 'X',
        tt: 'X',
        uk: 'X',
        uz: 'X',
    },

    color: '#0f1419',
};
